export class FontLoader
{
  private static readonly RUBIK_WEIGHTS = [400, 700, 900];

  public static async preloadAll(): Promise<void>
  {
    const fonts = ( document as any ).fonts as FontFaceSet | undefined;
    if ( !fonts )
      return;

    const specs: string[] = [];
    for ( const weight of this.RUBIK_WEIGHTS )
    {
      specs.push( `${weight} 16px Rubik` );
    }

    await Promise.all( specs.map( spec => fonts.load( spec ).catch( () => [] ) ) );
    await fonts.ready;
  }
}
